import script from "./productsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./productsTable.vue?vue&type=script&setup=true&lang=js"

import "./productsTable.vue?vue&type=style&index=0&id=46ea0f36&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ea0f36"]])

export default __exports__